<template>
    <div :style="{ height: pdfProps.height + 'px', width: pdfProps.width + 'px' }">
        <div v-if="formMRes" class="pdf-main">
            <div class="header">
                <img src="../../../assets/img/form_m_pdf_logo.png" />
                <div class="header-right">
                    <h2>CENTRAL BANK OF NIGERIA FROM SUBMISSION</h2>
                    <h5>FOREIGN EXCHANGE (MONITORING AND MISCELLANEOUS PROVISIONS) DECREE 1995</h5>
                    <div class="hr"></div>
                    <div class="header-data mt-2">
                        <div class="d-flex flex-column">
                            <div>
                                <h3 class="bold">Form M</h3>
                            </div>
                            <div class="small-text bold">
                                (Application to import)
                            </div>
                        </div>
                        <div class="d-flex flex-column ml-5">
                            <h6 class="bold">
                                VALID FOR FOREX?
                            </h6>
                            <div class="header-text-box mt-2">
                                {{ String(formMRes.valid_forex) === "1" ? "YES" : String(formMRes.valid_forex) === "0" ? "NO" : "" }}
                            </div>
                        </div>
                        <div class="d-flex flex-column">
                            <h6 class="bold">
                                PREFIX
                            </h6>
                            <div class="header-text-box mt-2">
                                {{ formMRes.form_m_prefix }}
                            </div>
                        </div>
                        <div class="d-flex flex-column">
                            <h6 class="bold">
                                BANK
                            </h6>
                            <div class="header-text-box mt-2">
                                {{ value(formMRes.ad_bank_code) }}
                            </div>
                        </div>
                        <div class="d-flex flex-column">
                            <h6 class="bold">
                                YEAR
                            </h6>
                            <div class="header-text-box mt-2">
                                {{ formMRes.form_m_year }}
                            </div>
                        </div>
                        <div class="d-flex flex-column">
                            <h6 class="bold">
                                NUMBERING
                            </h6>
                            <div class="header-text-box mt-2">
                                {{ formMRes.form_number }}
                            </div>
                        </div>
                        <div class="d-flex flex-column">
                            <h6 class="bold">
                                APPLICATION NUMBER
                            </h6>
                            <div class="header-text-box mt-2 bigger">
                                {{ formMRes.form_m_number }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-100 d-flex justify-content-end align-items-center mt-1 mb-1 small-text">
                <div class="bold mr-1">END OF VALIDITY</div>
                <div style="height: 20px;" class="header-text-box py-0">
                    {{ String(formMRes.valid_until).split("-").reverse().join("/") }}
                </div>
            </div>
            <div class="main-table">
                <table class="bl bt br">
                    <tr>
                        <td>
                            <div class="d-flex flex-column">
                                <h6>1. Name and Address of Applicant's Banker (Authorised Dealer)</h6>
                                <div>{{ displayText(formMRes.ad_bank_code) }}, {{ formMRes.ad_bank_address }}</div>
                            </div>
                        </td>
                        <td>
                            <div class="d-flex flex-column">
                                <h6>Branch Details</h6>
                                <div>{{ formMRes.ad_branch }}</div>
                            </div>
                        </td>
                    </tr>
                </table>
                <div class="table-hr"></div>
                <table class="bl br">
                    <tr>
                        <td rowspan="2" class="br">
                            <div class="d-flex flex-column">
                                <h6>2. Applicant's Name and Address</h6>
                                <div>
                                    {{ formMRes.app_name }}<br />{{ formMRes.app_address }}
                                </div>
                            </div>
                        </td>
                        <td class="bb br">
                            <div class="d-flex flex-column">
                                <h6>3. Applicant's RC No.</h6>
                                <div>{{ formMRes.rc_number }}</div>
                            </div>
                        </td>
                        <td class="bb br">
                            <div class="d-flex flex-column">
                                <h6>4. Applicant's TIN</h6>
                                <div>{{ formMRes.tin }}</div>
                            </div>
                        </td>
                        <td class="bb">
                            <div class="d-flex flex-column">
                                <h6>5. Applicant's NEPC Reg. No.</h6>
                                <div></div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="br">
                            <div class="d-flex flex-column">
                                <h6>6. Applicant's Phone</h6>
                                <div>{{ formMRes.app_phone }}</div>
                            </div>
                        </td>
                        <td class="br">
                            <div class="d-flex flex-column">
                                <h6>7. Applicant's Fax</h6>
                                <div>{{ formMRes.app_fax }}</div>
                            </div>
                        </td>
                        <td>
                            <div class="d-flex flex-column">
                                <h6>8. Applicant's Email</h6>
                                <div>{{ formMRes.app_email }}</div>
                            </div>
                        </td>
                    </tr>
                </table>
                <div class="table-hr"></div>
                <table class="bl br">
                    <tr>
                        <td rowspan="2" class="br">
                            <div class="d-flex flex-column">
                                <h6>9. Beneficiary's Name and Address</h6>
                                <div>
                                    {{ formMRes.bnf_name }}<br />{{ formMRes.bnf_address }}
                                </div>
                            </div>
                        </td>
                        <td class="bb br">
                            <div class="d-flex flex-column">
                                <h6>10. Applican'ts State Code and Name</h6>
                                <div>{{ formMRes.state_code }}, {{ formMRes.app_name }}</div>
                            </div>
                        </td>
                        <td class="bb br">
                            <div class="d-flex flex-column">
                                <h6>11. Beneficiary's Phone</h6>
                                <div>{{ formMRes.bnf_phone }}</div>
                            </div>
                        </td>
                        <td class="bb">
                            <div class="d-flex flex-column">
                                <h6>12. Beneficiary's Fax</h6>
                                <div>{{ formMRes.bnf_fax }}</div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="br">
                            <div class="d-flex flex-column">
                                <h6>13. Beneficiary's Email</h6>
                                <div>{{ formMRes.bns_email }}</div>
                            </div>
                        </td>
                        <td colspan="2">
                            <div class="d-flex flex-column">
                                <h6>14. By Order of</h6>
                                <div></div>
                            </div>
                        </td>
                    </tr>
                </table>
                <div class="table-hr"></div>
                <table class="bl br">
                    <tr>
                        <td rowspan="2" class="br">
                            <div class="d-flex flex-column">
                                <h6>15. General Description of Goods</h6>
                                <div></div>
                            </div>
                        </td>
                        <td class="bb br">
                            <div class="d-flex flex-column">
                                <h6>16. Net Weight</h6>
                                <div class="number">
                                    {{ formMRes.sgd_goods.reduce((accumulator, object) => {return accumulator + object.net_weight}, 0) }}
                                </div>
                            </div>
                        </td>
                        <td class="bb br">
                            <div class="d-flex flex-column">
                                <h6>17. Gross Weight</h6>
                                <div class="number">
                                    {{ formMRes.sgd_goods.reduce((accumulator, object) => {
                                        if (object.gross_weight)
                                            return accumulator + object.gross_weight;
                                        return accumulator + 0;
                                    }, 0) }}
                                </div>
                            </div>
                        </td>
                        <td class="bb">
                            <div class="d-flex flex-column">
                                <h6>18. Total Number of Items</h6>
                                <div class="number">{{ formMRes.sgd_goods.length }}</div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="br">
                            <div class="d-flex flex-column">
                                <h6>19. Air Ticket Number</h6>
                                <div></div>
                            </div>
                        </td>
                        <td class="br">
                            <div class="d-flex flex-column">
                                <h6>20. Airline</h6>
                                <div></div>
                            </div>
                        </td>
                        <td>
                            <div class="d-flex flex-column">
                                <h6>21. Route</h6>
                                <div></div>
                            </div>
                        </td>
                    </tr>
                </table>
                <div style="height: 3px;" class="table-hr"></div>
                <div class="bl bb br d-flex w-100 p-1 align-items-center">
                    <h6 class="bold" style="margin: 5px 0px">22. ITEMS</h6>
                </div>
                <table class="bl br goods-table">
                    <tr>
                        <th style="width: 60px" class="br">
                            <h6>No.</h6>
                        </th>
                        <th class="br">
                            <h6>HS code</h6>
                        </th>
                        <th style="width: 200px;" class="br">
                            <h6>Description of Goods</h6>
                        </th>
                        <th style="width: 70px;" class="br">
                            <h6>St. of Goods</h6>
                        </th>
                        <th class="br">
                            <h6>Sector Purpose</h6>
                        </th>
                        <th class="br" colspan="2">
                            <h6>Packages</h6>
                            <div class="d-flex flex-row">
                                <div style="text-align: right;" class="w-100">Qty</div>
                                <div style="text-align: center;" class="w-100">Type</div>
                            </div>
                        </th>
                        <!-- <th class="br"><h6>MERGED</th</h6>> -->
                        <th class="br">
                            <h6>Gross W.</h6>(kg)
                        </th>
                        <th class="br">
                            <h6>Net W.</h6>(kg)
                        </th>
                        <th class="br" colspan="2">
                            <h6>Unit of Meas.</h6>
                            <div class="d-flex flex-row">
                                <div style="text-align: right;" class="w-100">Qty</div>
                                <div style="text-align: center;" class="w-100">Type</div>
                            </div>
                        </th>
                        <!-- <th class="br"><h6>MERGED</th</h6>> -->
                        <th class="br">
                            <h6>U. Price</h6>(USD)
                        </th>
                        <th class="br">
                            <h6>FOB Value</h6>(USD)
                        </th>
                        <th>
                            <h6>Freight, Charg.</h6>(USD)
                        </th>
                    </tr>
                    <!-- <tr v-for="good in goods"> -->
                    <tr v-for="item in formMRes.sgd_goods">
                        <td class="br bt">{{ item.item_no }}</td>
                        <td class="br bt">{{ item.hs_code }}</td>
                        <td class="br bt">{{ item.good_name }}</td>
                        <td class="br bt">{{ item.state_of_good === 1 ? "Y" : "N" }}</td>
                        <td class="br bt">{{ item.sectoral_purpose }}</td>
                        <td class="br bt number">{{ Number(item.packages_qty).toFixed(3) }}</td>
                        <td class="br bt">{{ displayText(item.packages_code) }}</td> 
                        <td class="br bt number">{{ item.gross_weight ? item.gross_weight : 0 }}</td>
                        <td class="br bt number">{{ item.net_weight }}</td>
                        <td class="br bt number">{{ item.measure_qty }}</td>
                        <td class="br bt">{{ displayText(item.measure_code) }}</td>
                        <td class="br bt number">{{ item.unit_price }}</td>
                        <td class="br bt number">{{ item.fob_value }}</td>
                        <td class="bt number">{{ item.freight_charges }}</td>
                    </tr>
                </table>
                <div style="height: 3px;" class="table-hr"></div>
                <table class="bl br">
                    <tr>
                        <td class="br">
                            <div class="d-flex flex-column">
                                <h6>23. Total FOB Value</h6>
                                <div class="number">{{ formMRes.total_fob_value }}</div>
                            </div>
                        </td>
                        <td class="br">
                            <div class="d-flex flex-column">
                                <h6>24. Total Freight Charges</h6>
                                <div class="number">{{ formMRes.total_freight_charges }}</div>
                            </div>
                        </td>
                        <td class="br">
                            <div class="d-flex flex-column">
                                <h6>25. Total Ancillary Charges</h6>
                                <div class="number">{{ formMRes.total_anc_charges }}</div>
                            </div>
                        </td>
                        <td style="width: 15%;" class="br">
                            <div class="d-flex flex-column">
                                <h6>26. Insurance Value (Nairas)</h6>
                                <div class="number">{{ formMRes.insh_value }}</div>
                            </div>
                        </td>
                        <td style="width: 15%;" class="br">
                            <div class="d-flex flex-column">
                                <h6>27. Currency Code</h6>
                                <div class="number">{{ displayText(formMRes.curr_code) }}</div>
                            </div>
                        </td>
                        <td style="width: 15%;">
                            <div class="d-flex flex-column">
                                <h6>28. Exchange Rate</h6>
                                <div class="number">{{ formMRes.exch_rate }}</div>
                            </div>
                        </td>
                    </tr>
                </table>
                <table class="bl br bt">
                    <tr>
                        <td class="br">
                            <div class="d-flex flex-column">
                                <h6>29. Total C&F Value in Figure</h6>
                                <div class="number">{{ formMRes.total_cf_value }}</div>
                            </div>
                        </td>
                        <td style="width: 35%;" class="br">
                            <div class="d-flex flex-column">
                                <h6>30. Source of Funds</h6>
                                <div>{{ formMRes.source_funds }}</div>
                            </div>
                        </td>
                        <td style="width: 15%;" class="br">
                            <div class="d-flex flex-column">
                                <h6>31. Proforma Inv. No.</h6>
                                <div>{{ formMRes.proforma_number }}</div>
                            </div>
                        </td>
                        <td style="width: 15%;" class="br">
                            <div class="d-flex flex-column">
                                <h6>32. Proforma Inv. Date</h6>
                                <div>{{ String(formMRes.proforma_date).split("-").reverse().join("/") }}</div>
                            </div>
                        </td>
                        <td style="width: 15%;">
                            <div class="d-flex flex-column">
                                <h6>33. Payment Date</h6>
                                <div>{{ String(formMRes.payment_date).split("-").reverse().join("/") }}</div>
                            </div>
                        </td>
                    </tr>
                </table>
                <table class="bl br bt">
                    <tr>
                        <td style="width: 55%;" class="br">
                            <div class="d-flex flex-column">
                                <h6>34. Payment Mode</h6>
                                <div>{{ displayText(formMRes.payment_mode) }}</div>
                            </div>
                        </td>
                        <td style="width: 15%;" class="br">
                            <div class="d-flex flex-column">
                                <h6>35. Transfer Mode</h6>
                                <div>{{ displayText(formMRes.transfer_mode) }}</div>
                            </div>
                        </td>
                        <td style="width: 15%;" class="br">
                            <div class="d-flex flex-column">
                                <h6>36. TOD</h6>
                                <div>{{ displayText(formMRes.terms_delivery) }}</div>
                            </div>
                        </td>
                        <td style="width: 15%;">
                            <div class="d-flex flex-column">
                                <h6>37. Shipment Date</h6>
                                <div>{{ String(formMRes.shipment_date).split("-").reverse().join("/") }}</div>
                            </div>
                        </td>
                    </tr>
                </table>
                <table class="bl br bt">
                    <tr>
                        <td class="br">
                            <div class="d-flex flex-column">
                                <h6>38. Mode of Transport</h6>
                                <div>{{ displayText(formMRes.transp_mode) }}</div>
                            </div>
                        </td>
                        <td class="br">
                            <div class="d-flex flex-column">
                                <h6>39. Country of Origin</h6>
                                <div>{{ displayText(formMRes.transp_country) }}</div>
                            </div>
                        </td>
                        <td class="br">
                            <div class="d-flex flex-column">
                                <h6>40. Country of Supply</h6>
                                <div>{{ formMRes.supply_country }}</div>
                            </div>
                        </td>
                        <td class="br">
                            <div class="d-flex flex-column">
                                <h6>41. Port of Discharge</h6>
                                <div>{{ formMRes.discharge_port }}</div>
                            </div>
                        </td>
                        <td class="br">
                            <div class="d-flex flex-column">
                                <h6>42. Port of Loading</h6>
                                <div>{{ formMRes.loading_port }}</div>
                            </div>
                        </td>
                        <td class="br">
                            <div class="d-flex flex-column">
                                <h6>43. Customs Office</h6>
                                <div>{{ formMRes.cust_office }}</div>
                            </div>
                        </td>
                    </tr>
                </table>
                <div class="table-hr"></div>
                <table class="bl bb br">
                    <tr>
                        <td class="br">
                            <div class="d-flex flex-column">
                                <h6>44. Designated Bank</h6>
                                <div>{{ formMRes.design_bank }}</div>
                            </div>
                        </td>
                        <td>
                            <div class="d-flex flex-column">
                                <h6>45. Inspection Agent</h6>
                                <div>{{ formMRes.insp_agent }}</div>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
            <div class="second-table">
                <div class="table-hr"></div>
                <table class="br bb bl">
                    <tr>
                        <td class="br">
                            <div class="d-flex flex-column">
                                <h6>46. Applicant's Endorsement</h6>
                            </div>
                        </td>
                        <td>
                            <div class="d-flex flex-column">
                                <h6>47. Authorised Dealer's Endorsement</h6>
                            </div>
                        </td>
                    </tr>
                    <tr class="bt">
                        <td class="br bt">
                            <div class="d-flex flex-column">
                                <h6>Full Name</h6>
                                <div>{{ formMRes.app_name }}</div>
                            </div>
                        </td>
                        <td class="bt">
                            <div class="d-flex flex-column">
                                <h6>Full Name</h6>
                                <div>{{ formMRes.app_repr_name }}</div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="br bt" style="height: 100px;">
                            <div class="d-flex flex-column" style="justify-content: start;">
                                <h6>Stamp, Signature & Date</h6>
                                <div></div>
                            </div>
                        </td>
                        <td class="bt" style="height: 100px;">
                            <div class="d-flex flex-column" style="justify-content: start;">
                                <h6>Stamp, Signature & Date</h6>
                                <div></div>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        pdfProps: {
            type: Object,
            required: true,
            // {
            //     width: Number               // Page content width without margins
            //     height: Number              // Page content height without margins (page will be auto added if content is bigger)
            //     childFullyLoaded: Function  // Call me on fully load
            // }
        },
        documentId: {
            type: String | Number,
            required: true,
        },
    },
    data: () => ({
        libsNeeded: {
            adb: "ad_bank_code",
            measure: null, //sgd_goods.measure_code  list, update manually
            pkg_kind: null, //sgd_goods.packages_code  list, update manually
            currency: "curr_code",
            payment_type: "payment_mode",
            transporttype: "transfer_mode",
            transp_mode: "transp_mode",
            country: "transp_country",
            delivery_term: "terms_delivery",
        },
        libs: null,
        formMRes: null,
    }
    ),
    mounted() {
        this.getFormM()
        this.getLibs()
    },
    computed: {
        allDataLoaded() {
            return this.formMRes && this.libs;
        },
    },
    watch: {
        allDataLoaded: function (value) {
            if (value) {
                this.updateValues()
                this.$nextTick(function () { // Wait for DOM update
                    this.pdfProps.childFullyLoaded()
                });
            }
        }
    },
    methods: {
        value(val){
            if (val === null) return ""
            if (typeof val === 'object') return val.value
            else return val
        },
        displayText(val){
            if (val === null) return ""
            if (typeof val === 'object') return val.display_text
            else return val
        },
        getFormM() {
            axios.get(`${window.base}/document/GetForm_M?doc_id=${this.documentId}`).then(response=>{
                this.formMRes = response.data
            })
        },
        getLibs() {
            let promises = []
            Object.keys(this.libsNeeded).forEach((lib)=>{
                promises.push(axios.get(`${window.base}/library?type=${lib}&query=&qty=1000&lang=${this.$i18n.locale}`))
            })
            Promise.all(promises).then((responses)=>{
                let libs = {}
                responses.forEach((response, index)=>{
                    libs[Object.keys(this.libsNeeded)[index]] = response.data
                })
                this.libs = libs
            })
        },
        updateValues(){
            Object.keys(this.libsNeeded).forEach((lib) => {
                if (!["measure", "pkg_kind"].includes(lib)){
                    this.libs[lib].forEach((item) => {
                        if (item.value == this.formMRes[this.libsNeeded[lib]]){
                            this.formMRes[this.libsNeeded[lib]] = item;
                        }
                    });
                }
            });
            this.formMRes.sgd_goods.forEach((item) => {
                this.libs.measure.forEach((measure) => {
                    if (measure.value == item.measure_code) item.measure_code = measure;
                });
                this.libs.pkg_kind.forEach((pkg_kind) => {
                    if (pkg_kind.value == item.packages_code) item.packages_code = pkg_kind;
                });
            });
        }
    },
};
</script>
<style>
.pdf-main {
    display: flex;
    flex-direction: column;
    font-family: "Helvetica";
    color: #595959;
    line-height: 1.1em;
    margin: 0px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
}

.pdf-main div {
    font-family: "Helvetica";
    color: #595959;
    line-height: 1.1em;
    margin: 0px;
}

.pdf-main .pdf-main h1,
.pdf-main h2,
.pdf-main h3,
.pdf-main h4,
.pdf-main h5,
.pdf-main h6 {
    font-family: "Helvetica";
    color: #595959;
    line-height: 1.1em;
    margin: 0px;
}

.pdf-main h2 {
    margin: 8px 0px;
    letter-spacing: 0.01em;
}

.pdf-main h5 {
    margin: 6px 0px;
    letter-spacing: 0.01em;
}

.small-text {
    font-size: 12px;
}

.bold {
    font-weight: bold;
}

.hr {
    width: 100%;
    height: 1px;
    background-color: #595959;
    margin: 12px 0px;
}

.table-hr {
    width: 100%;
    height: 5px;
    background-color: #919191;
    margin: 0px;
}

.header {
    width: 100%;
    height: 200px;
    display: flex;
    flex-direction: row;
    gap: 40px;
}

.header img {
    height: 100%;
}

.header-right {
    justify-content: end;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.header-data {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.header-text-box {
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px 16px;
    border: 1px solid #595959;
    width: fit-content;
}

.header-text-box.bigger {
    height: 40px;
    padding: 0px 28px;
    font-size: 18px;
}

.main-table,
.second-table {
    width: 100%;
}

.pdf-main table h6 {
    font-weight: bold;
    margin-bottom: 5px;
}

.pdf-main table th h6 {
    margin: 0px;
}

.pdf-main table td {
    padding: 4px;
    height: 50.5px;
    vertical-align: top;
}

.pdf-main table th {
    padding: 4px;
    font-weight: normal;
    text-align: center;
}

.pdf-main .goods-table tr td {
    padding: 4px;
    font-weight: normal;
    text-align: center;
    vertical-align: middle;
}

.pdf-main .bl {
    border-left: 1px solid #919191;
}

.pdf-main .bt {
    border-top: 1px solid #919191;
}

.pdf-main .br {
    border-right: 1px solid #919191;
}

.pdf-main .bb {
    border-bottom: 1px solid #919191;
}

.pdf-main table {
    table-layout: fixed;
    width: 100%;
}

.pdf-main td .number {
    text-align: right;
}

.pdf-main .goods-table td.number {
    text-align: right;
}

.pdf-main table td div.d-flex.flex-column {
    height: 100%;
    justify-content: space-between;
}

.pdf-main .second-table {
    height: auto;
    margin-bottom: 0px;
    margin-top: auto;
}
</style>